export default __webpack_public_path__ + "static/media/challenge-header.237fc034.png";